import React, {Suspense, useEffect} from 'react';
import {connect} from 'react-redux';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {login, logout} from './actions/authAction';
import './App.css';
import GlobalLoader from './components/GlobalLoader/GlobalLoader';
import LOADER from './components/utils/loader';
import removeLocalItem from './services/removeLocalStorage';
import AutoLogout from './components/AutoLogout/AutoLogout';

// import LoginComponent from "./components/login/Login";
// import Wrapper from "./components/dashboard/wrapper";
// import PrivateRoute from "./components/utils/PrivateRoute";
// import LoginWrapper from "./components/utils/LoginWrapper";

const LoginComponent = React.lazy(() => import('./components/login/Login'));
const Wrapper = React.lazy(() => import('./components/dashboard/wrapper'));
const PrivateRoute = React.lazy(
  () => import('./components/utils/PrivateRoute')
);
const LoginWrapper = React.lazy(
  () => import('./components/utils/LoginWrapper')
);

function App(props) {
  //auth check if token exists
  let Token = localStorage.getItem('Token');
  if (
    Token &&
    Token !== null &&
    Token !== undefined &&
    Token !== 'null' &&
    Token !== 'undefined'
  ) {
    props.login(Token);
  }

  useEffect(() => {
    if (window.location.pathname === '/login') {
      removeLocalItem();
    }
  }, [window.location.pathname]);

  // Global input validation for all text and search fields
  useEffect(() => {
    const handleGlobalBlur = (e) => {
      const target = e.target;
      if (target && target.tagName && target.tagName.toLowerCase() === 'input') {
        const type = target.type.toLowerCase();
        
        // Only apply to standard text and search fields (ignore email, password, etc.)
        if (type === 'text' || type === 'search') {
          const name = (target.name || '').toLowerCase();
          const placeholder = (target.placeholder || '').toLowerCase();
          
          // Do not filter if it's acting as a password field
          if (name.includes('password') || placeholder.includes('password')) {
            return;
          }

          const value = target.value;
          let shouldClear = false;

          // Check if it's a mobile/phone field
          if (name.includes('mobile') || name.includes('phone')) {
            if (isNaN(value) && value !== '') {
              shouldClear = true;
            }
          } else {
            // General text fields: only allow letters, digits, spaces, -, _, ., and ,
            if (/[^a-zA-Z0-9 \-_.,]/.test(value)) {
              shouldClear = true;
            }
          }

          if (shouldClear) {
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
            if (nativeInputValueSetter) {
              nativeInputValueSetter.call(target, '');
              const ev = new Event('input', { bubbles: true });
              target.dispatchEvent(ev);
            }
          }
        }
      }
    };

    // Use capture phase (true) so it runs before React's synthetic event blur handlers or other things
    document.addEventListener('blur', handleGlobalBlur, true);
    return () => {
      document.removeEventListener('blur', handleGlobalBlur, true);
    };
  }, []);

  return (
    <div className='container-fluid'>
      <LOADER />
      <ToastContainer />
      <Suspense fallback={<GlobalLoader />}>
        <BrowserRouter>
          <AutoLogout />
          <Switch>
            <Route exact path='/'>
              <Redirect to={{pathname: '/dashboard/root'}} />
            </Route>

            <LoginWrapper exact path='/login'>
              <Suspense fallback={<GlobalLoader />}>
                <LoginComponent />
              </Suspense>
            </LoginWrapper>
            <PrivateRoute path='/dashboard'>
              <Suspense fallback={<GlobalLoader />}>
                <Wrapper />
              </Suspense>
            </PrivateRoute>
            <Route>
              <Redirect to='/' />
            </Route>
          </Switch>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {login, logout})(App);
